import { render } from "./Tariffes.vue?vue&type=template&id=4a8a2bd1"
import script from "./Tariffes.vue?vue&type=script&lang=js"
export * from "./Tariffes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__